/**
 * Admin Guard
 * Protects routes that require admin privileges
 * Uses Angular Signals for reactive state
 */

import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { RouteBuilder } from '../constants/routes.constants';

export const adminGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAdmin()) {
    return true;
  }

  // If not authenticated at all, redirect to offers (users can use login modal)
  if (!authService.isAuthenticated()) {
    sessionStorage.setItem('auth_redirect_after_login', state.url);
    router.navigate([RouteBuilder.offers()]);
    return false;
  }

  // If authenticated but not admin, redirect to offers page
  router.navigate([RouteBuilder.offers()]);
  return false;
};
